import React from 'react';
import './Overview.css'; // Import the CSS file

const Overview = () => {
  return (
    <div className="overview-container">
      <div className="our-services">
        <h1>
          <span className="mobile-hide">Our </span>Services
        </h1>
        <p>
          Rami Elite offers expert Muay Thai and Taekwondo programs for kids and adults. For over 25 years, we’ve built a safe, collaborative community where hundreds of students have gained confidence, self-defense skills, and even competed in world-class tournaments. Join us to train, grow, and become part of a legacy of excellence!
        </p>
      </div>
    </div>
  );
};

export default Overview;